// Store with TypeScript
import { create } from "zustand";

interface FastaStore {
  uploadResults: string;
  isUploadVisible: boolean;

  setUploadVisibilitiy: (isUploadVisible: boolean) => void;
  setUploadResults: (uploadResults: string) => void;
}

export const useFastaStore = create<FastaStore>((set) => ({
  uploadResults: "",
  isUploadVisible: false,

  setUploadVisibilitiy: (isUploadVisible: boolean) => set({ isUploadVisible }),
  setUploadResults: (uploadResults: string) => set({ uploadResults }),
}));
